import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    linkResendInvitationSuccess: 'Invitation successfully sent to {name}!',
  },
  fr: {
    linkResendInvitationSuccess: 'Invitation bien envoyée à {name}!',
  },
} as const);
